import React, {Fragment} from "react";
import {DialogActions} from "@mui/material";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import {useTranslation} from "react-i18next";
import FullscreenDialog from "../fullscreen-dialog";

const SettingsDialog = ({
  open = false,
  title = null,
  onClose = null,
  onSubmit = null,
  customSubmitLabel = null,
  className = "",
  children,
  ...props
}) => {
  const {t} = useTranslation();

  return (
    <FullscreenDialog
      {...props}
      open={open}
      title={title}
      onClose={onClose}
      className={`components__dialog--settings ${className}`}
    >
      <DialogContent
        sx={{
          minHeight: "400px"
        }}
        className="components__dialog__content"
      >
        {children}
      </DialogContent>
      <DialogActions className="components__dialog__actions">
        {onSubmit ? (
          <Fragment>
            <Button className="components__dialog__btn components__dialog__btn--cancel" onClick={onClose}>
              {t("commons.confirm.cancel")}
            </Button>
            <Button className="components__dialog__btn components__dialog__btn--submit" onClick={onSubmit}>
              {customSubmitLabel || t("commons.confirm.submit")}
            </Button>
          </Fragment>
        ) : (
          <Button className="components__dialog__btn components__dialog__btn--close" onClick={onClose}>
            {t("commons.confirm.close")}
          </Button>
        )}
      </DialogActions>
    </FullscreenDialog>
  );
};

export default SettingsDialog;
